const STORAGE_KEY = "player-volume";
const UNMUTE_LEVEL = 50;

// The listener's volume preference, shared by every PlayerController (a new
// one is created per era) and saved across visits. Changes are announced with
// a `player:volume` event.
class PlayerVolume {
  constructor() {
    Object.assign(this, { level: 100, muted: false }, load());
  }

  get isSilent() {
    return this.muted || this.level === 0;
  }

  // Choosing a volume implies wanting to hear it, so this also unmutes.
  set(level) {
    this.update({ level: Math.round(Math.min(Math.max(level, 0), 100)), muted: false });
  }

  // Unmuting at zero volume would still be silent, so that also brings the
  // volume up.
  toggleMute() {
    if (this.isSilent) {
      this.update({ level: this.level || UNMUTE_LEVEL, muted: false });
    } else {
      this.update({ muted: true });
    }
  }

  update({ level = this.level, muted = this.muted }) {
    if (level === this.level && muted === this.muted) return;

    this.level = level;
    this.muted = muted;
    save({ level, muted });
    window.dispatchEvent(new CustomEvent("player:volume", { detail: { level, muted } }));
  }
}

// Storage can be unavailable (e.g. blocked site data); the preference then
// just lasts for the page.
function load() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY)) ?? {};
  } catch {
    return {};
  }
}

function save(preference) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(preference));
  } catch {}
}

export default new PlayerVolume();
